import type { IRecordingHeader } from './recording';
import { recordingSchema } from './recording';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import { forRecordingsModule } from '../channels';

export const AVAILABLE = 'RECORDINGS/AVAILABLE';

export const availableActionSchema = objectSchemaOf<IAvailableAction>({
  type: Joi.string().required().valid(AVAILABLE),
  payload: recordingSchema.required(),
});

export interface IAvailableAction {
  type: typeof AVAILABLE;
  payload: IRecordingHeader;
}

export const available = actionCreator({
  type: AVAILABLE,
  schema: availableActionSchema,
  channels: [forRecordingsModule],
});
